// Root path khi FE chạy dưới một prefix, vd. https://<host>/z2/.
// entrypoint.sh thay placeholder bằng env  lúc container khởi động.
// Không đặt env, hoặc chạy dev (placeholder chưa bị thay), thì về '/' như cũ.
const raw = process.env.VUE_APP_BASE_PATH || ''
const trimmed = raw.startsWith('ENV_') ? '' : raw.replace(/^\/+|\/+$/g, '')

// Luôn có '/' ở đầu và cuối: '/' hoặc '/z2/'
export const BASE_PATH = trimmed ? `/${trimmed}/` : '/'
